import { Edit3, Eye, EyeOff, Shield } from "lucide-react";
import type { FolderPermission } from "@secure-caseworker/shared";

/**
 * Shared permission selector component for folder permissions
 */
interface FolderPermissionSelectorProps {
  value: FolderPermission;
  onChange: (permission: FolderPermission) => void;
  disabled?: boolean;
}
export function FolderPermissionSelector({
  value,
  onChange,
  disabled = false,
}: FolderPermissionSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
        <Shield className="w-4 h-4 inline mr-1" />
        Client Access
      </label>
      <div className="space-y-2">
        <label className="flex items-center p-3 border border-gray-300 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          <input
            type="radio"
            name="clientPermission"
            value="none"
            checked={value === "none"}
            onChange={(e) => onChange(e.target.value as FolderPermission)}
            disabled={disabled}
            className="mr-3"
          />
          <div className="flex items-center gap-2 flex-1">
            <EyeOff className="w-4 h-4 text-gray-500" />
            <div>
              <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                Private
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Hidden from clients
              </div>
            </div>
          </div>
        </label>

        <label className="flex items-center p-3 border border-gray-300 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          <input
            type="radio"
            name="clientPermission"
            value="read"
            checked={value === "read"}
            onChange={(e) => onChange(e.target.value as FolderPermission)}
            disabled={disabled}
            className="mr-3"
          />
          <div className="flex items-center gap-2 flex-1">
            <Eye className="w-4 h-4 text-blue-500" />
            <div>
              <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                Read-Only
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Clients can view/download only
              </div>
            </div>
          </div>
        </label>

        <label className="flex items-center p-3 border border-gray-300 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          <input
            type="radio"
            name="clientPermission"
            value="modify"
            checked={value === "modify"}
            onChange={(e) => onChange(e.target.value as FolderPermission)}
            disabled={disabled}
            className="mr-3"
          />
          <div className="flex items-center gap-2 flex-1">
            <Edit3 className="w-4 h-4 text-green-500" />
            <div>
              <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                Modifiable
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                Clients can upload/edit/delete files
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
}
